<div class="d-flex-column gap-2">
  <label for="blueTeam" class="form-label">Left Team</label>
  <input id="blueTeam" class="form-control" required [(ngModel)]="match.teams.left.name">
  <app-icon-selector [icons]="profiles.teamLogos" [(selectedIcon)]="match.teams.left.logo" />
</div>

<div class="d-flex-column gap-2">
  <label for="redTeam" class="form-label">Right Team</label>
  <input id="redTeam" class="form-control" required [(ngModel)]="match.teams.right.name">
  <app-icon-selector [icons]="profiles.teamLogos" [(selectedIcon)]="match.teams.right.logo" />
</div>
